import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { SyncDataSourceDocument } from './sync.generated';

export const useSyncDataSource = (options: ApiOptions<typeof SyncDataSourceDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(SyncDataSourceDocument, {
    ...useNotifications(SyncDataSourceDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.data_sources.sync_success'),
    }),
    ...options,
  });
};
